export function beginSend(sendInFlightRef, entry) {
  const active = sendInFlightRef.current
  if (active?.threadId === entry.threadId) return null
  sendInFlightRef.current = entry
  return entry
}

export function clearSend(sendInFlightRef, entry) {
  if (sendInFlightRef.current === entry) {
    sendInFlightRef.current = null
  }
}
